module.exports = __webpack_public_path__ + "static/media/sliders-v-square.24242cb5.svg";